import { useEffect } from "react";
import { piKey } from "../../../../app/app.sideEffects/useURLParams.sideEffects.js";
import axios from "axios";

export default function useMapboxData(props) {
  // Mapbox Serverdaten (mapbox key und so)
  useEffect(() => {
    if (piKey == null) return;
    axios
      .get(`${process.env.REACT_APP_BACKEND_INI_URL}?piKey=${piKey}`)
      .then((response) => {
        props.setCustomerInformation(response.data.customer);
      })
      .catch((error) => {
        throw Error(error);
      });
  }, [piKey]);
}
